const styles = {
    headerText: {
        position: "relative",
        paddingLeft: "33px",
        fontFamily: "IBM Plex Sans",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "23px",
        lineHeight: "28px",
        color: "#000000",
    },
    selectorLabel: {
        fontSize: "14px",
        fontFamily: "Roboto",
        lineHeight: "18px",
        letterSpacing: "0.2px",
        color: "#6D7885",
        marginBottom: "12px",
        marginLeft: "5.5px"
    },
    wrapper: {
        marginLeft: "18px",
        marginRight: "18px",
        width: "90.4vw",
        marginTop: "12px"
    },
    spinner: {
        marginTop: "25vh"
    },
    selectorWarningMessage: {
        margin: "0",
        padding: "0",
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.2px",
        color: "#6D7885",
        marginTop: "6px",
        marginLeft: "10px",
        width: "86.4vw",
        marginBottom: "23px"
    },
    nextButton: {
        width: "87.46vw",
        height: "44px",
        backgroundColor: "#06844D",
        borderRadius: "8px",
        marginTop: "39px"
    },
    errorMessage: {
        width: "296px",
        fontFamily: "Roboto",
        fontSize: "16px",
        lineHeight: "20px",
        letterSpacing: "0.1px",
        color: "#818C99",
        fontWeight: "400",
        marginTop: "172px",
        textAlign: "center",
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    imgClose: {
        height: "13px",
        width: "13px",
    },
    wrapperSelectRegion: {
        display: 'grid',
        gridTemplateColumns: 'calc(86.15vw - 13px) 13px',
        columnGap: '4.25vw',
        alignItems: 'center',
        padding: '0',
    },
}

export default styles;
